export default "__VITE_ASSET__0d66461a__"